module.exports = __webpack_public_path__ + "img/w3_chevron_left_black.3dcd09f6.3dcd09f6.png";